<template>
    <myinfo-row :label="label" pointer>
        <v-row>
            <v-col v-for="parent in areas_structured" :key="parent._id" cols="6" lg="">
                <v-row>
                    <v-col>{{ parent.name }}</v-col>
                </v-row>
                <v-row v-for="child in parent.children" :key="child._id">
                    <v-col>
                        <v-checkbox :label="child.name" v-model="input._areas" :value="child._id" hide-details dense class="my-0 py-0" @input="syncInput" @change="syncInput" />
                    </v-col>
                    <v-col cols="12" v-if="child.name == '기타(입력)' && value._areas.includes(child._id)" class="pt-0">
                        <v-text-field :value="findManualValue(parent)" hide-details dense class="my-0 py-0" outlined @input="(name) => syncManualInput(name, parent)" />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </myinfo-row>
</template>

<script>
import { INDIVIDUAL_KINDS } from "@/assets/variables";

import MyinfoRow from "./myinfo-row.vue";

export default {
    components: { MyinfoRow },
    props: ["value", "areas"],
    computed: {
        isSupporter() {
            return this.value.kind == INDIVIDUAL_KINDS.SUPPORTER.value;
        },
        label() {
            return this.isSupporter ? "자문분야" : "관심분야 ";
        },

        areas_structured() {
            const parents = (this.areas || []).filter(({ _parent }) => !_parent).sort((a, b) => a.order - b.order);
            const areas = parents.map((parent) => ({
                ...parent,
                children: (this.areas || []).filter(({ _parent }) => _parent == parent._id).sort((a, b) => a.order - b.order),
            }));
            return areas;
        },
    },
    data() {
        return {
            input: {
                _areas: [],
                areas_manual: [],
            },
        };
    },
    methods: {
        syncInput() {
            const { _areas, areas_manual } = this.input;
            this.$emit("input", {
                ...this.value,
                _areas,
                areas_manual,
            });
        },
        findManualValue({ _id: _parent }) {
            let target = this.input.areas_manual.find((area) => area._parent == _parent);
            if (!target) {
                this.input.areas_manual.push({ _parent, name: "" });
                target = this.input.areas_manual.find((area) => area._parent == _parent);
            }
            return target.name;
        },
        syncManualInput(name, { _id: _parent }) {
            this.input.areas_manual.find((area) => area._parent == _parent).name = name;
            this.syncInput();
        },
    },
    mounted() {
        this.input._areas = this.value._areas;
        this.input.areas_manual = this.value.areas_manual || [];
    },
    watch: {
        "input._areas"() {
            for (const area of this.input.areas_manual) {
                const parent = this.areas_structured.find(({ _id }) => _id == area._parent);
                const child = parent?.children?.find(({ name }) => name == "기타(입력)");
                if (!this.input._areas.includes(child?._id)) this.input.areas_manual = this.input.areas_manual.filter(({ _parent }) => _parent !== parent?._id);
            }
        },
    },
};
</script>

<style></style>
